<template lang="pug">

include ../../../../pug/mixins/index

+b.SPAN.range-slider.--list
  drag-helper(
    target-selector='.range-slider__knob',
    v-bind:disabled='disabled',
    @drag='drag',
    @dragend='dragEnd'
  )
    +e.SPAN.inner(ref='inner')
      +e.INPUT.hidden(type='text', :name='name', :value='actualValue')
      +e.SPAN.rail
      +e.SPAN.fill(:style="{ width: valuePercent + '%' }")
      +e.SPAN.knob(:style="{ left: valuePercent + '%' }")

</template>

<script>

import { RangeAbstract } from './range'

export default {
  mixins: [RangeAbstract],

  props: {
    list: {
      type: Array,
      required: true
    }
  },

  computed: {
    _min() { return 0 },

    _max() { return this.list.length - 1 },

    _step() { return 1 },
  },

  methods: {
    emitEvent(value, isDragEnd) {
      this.$emit('input', value)

      if (isDragEnd) {
        this.$emit('change', value)
      }
    }
  }
}

</script>


// WEBPACK FOOTER //
// src/js/shared/components/range-slider/list.vue